import { cacheStore } from './store'
import shareConfig from '@web-publish-id/shared/config'

const key = 'game_token_info'

/**
 * 获取缓存key
 */
const getKey = () => `${key}:${shareConfig.clientId}`

export const setGameTokenInfo = (info: any) => {
  cacheStore.setItem(getKey(), info)
}

export const getGameTokenInfo = () => {
  return cacheStore.getItem(getKey())
}

export const removeGameTokenInfo = () => {
  cacheStore.removeItem(getKey())
}

export const watchGameTokenInfo = (callback: (info: any) => void) => {
  return cacheStore.watch(getKey(), callback)
}
